module.exports = __webpack_public_path__ + "img/SUITE_WORD_WHITE.1f5ae198.png";